import { Navigate, Route, Routes, useLocation } from "react-router";
import { useApp } from "./app-context.tsx";
import { useAuthUser } from "./auth.ts";
import { useMe } from "./me.ts";
import { CatalogPage } from "./pages/Catalog.tsx";
import { CommunityPage } from "./pages/Community.tsx";
import { CommunityItemPage } from "./pages/CommunityItem.tsx";
import { ConfiguratorPage } from "./pages/Configurator.tsx";
import { MinePage } from "./pages/Mine.tsx";
import { ModerationPage } from "./pages/Moderation.tsx";
import { SharePage } from "./pages/Share.tsx";
import { DefaultFooter, DefaultHeader } from "./pages/defaults.tsx";

export function App() {
  const { brand, copy, auth } = useApp();
  const user = useAuthUser(auth);
  const location = useLocation();
  const me = useMe();
  const gallery = brand.config.features.publicGallery;
  const Header = brand.slots?.Header ?? DefaultHeader;
  const Footer = brand.slots?.Footer ?? DefaultFooter;
  const nav = [
    { label: copy("nav.catalog"), href: "/", active: location.pathname === "/" || location.pathname.startsWith("/design") },
    ...(gallery ? [{ label: copy("nav.community"), href: "/community", active: location.pathname.startsWith("/community") }] : []),
    ...(brand.config.features.saveConfigs ? [{ label: copy("nav.mine"), href: "/mine", active: location.pathname.startsWith("/mine") }] : []),
    ...(gallery && me.data?.plan === "staff" ? [{ label: copy("mod.title"), href: "/mod", active: location.pathname.startsWith("/mod") }] : []),
  ];
  return (
    <div className="app-shell" data-brand={brand.config.id}>
      <Header brand={brand.config} nav={nav} user={user} onSignIn={() => void auth.signIn()} onSignOut={() => void auth.signOut()} />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<CatalogPage />} />
          <Route path="/design/:id" element={<ConfiguratorPage />} />
          <Route path="/mine" element={<MinePage />} />
          <Route path="/share/:token" element={<SharePage />} />
          {gallery && <Route path="/community" element={<CommunityPage />} />}
          {gallery && <Route path="/community/:id" element={<CommunityItemPage />} />}
          {gallery && <Route path="/mod" element={<ModerationPage />} />}
          <Route path="/auth/callback" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer brand={brand.config} />
    </div>
  );
}
